import React from 'react';
import { Section } from './ui/Section';
import { Testimonial } from './Testimonial';
import { Heart } from 'lucide-react';
import { Wildflower } from './botanical/Wildflower';
export function TestimonialsGrid() {
  const testimonials = [{
    initials: 'MR',
    quote: 'Tenía miedo de no saber usarlo pero es clarísimo. Mi hijo tuvo tos de noche y en 20 minutos ya estaba mejor con el jarabe de cebolla. Increíble.',
    author: 'MARCELA R.',
    location: 'MENDOZA'
  }, {
    initials: 'SC',
    quote: 'El tomo de digestión me cambió la vida. Siempre terminaba con panza inflamada y ahora sé exactamente qué hacer. Lo recomiendo a todas mis amigas.',
    author: 'SOFÍA C.',
    location: 'LA PLATA'
  }, {
    initials: 'JP',
    quote: 'Soy mamá de tres y esto es lo que necesitaba. Tengo todo organizado, sé qué darle a cada uno según la edad y dejé de entrar en pánico de noche.',
    author: 'JULIA P.',
    location: 'TUCUMÁN'
  }, {
    initials: 'AR',
    quote: 'Lo compré con desconfianza y en la primera semana ya lo usé tres veces. El protocolo de garganta funciona mejor que lo que compraba en farmacia.',
    author: 'ANDRÉS R.',
    location: 'ROSARIO'
  }, {
    initials: 'VL',
    quote: 'El bono de la guía rápida lo imprimí y lo pegué en la cocina. Mi marido dice que soy médica ahora.',
    author: 'VALERIA L.',
    location: 'CÓRDOBA'
  }, {
    initials: 'DM',
    quote: 'Nunca había probado nada natural. Pensé que era todo cuento. Pero el jarabe de miel y limón para la tos de mi nena funcionó en una noche.',
    author: 'DANIELA M.',
    location: 'BUENOS AIRES'
  }, {
    initials: 'FM',
    quote: 'Lo del estrés y el sueño fue lo que más me sorprendió. Empecé el ritual nocturno y duermo mejor que hace años. No lo cambio por nada.',
    author: 'FERNANDA M.',
    location: 'MAR DEL PLATA'
  }, {
    initials: 'GO',
    quote: 'Vivo solo y siempre que me enfermaba no sabía qué hacer. Ahora tengo el botiquín armado y los protocolos listos. Me siento mucho más tranquilo.',
    author: 'GUILLERMO O.',
    location: 'SANTA FE'
  }];
  return <Section className="bg-forest-mist relative overflow-hidden" data-id="element-406">
      <Wildflower className="absolute top-40 -left-20 w-80 h-80 text-moss opacity-10 blur-md" data-id="element-407" />

      <div className="text-center mb-12 relative z-10" data-id="element-408">
        <div className="inline-flex items-center justify-center gap-2 text-honey-dark font-bold tracking-widest uppercase mb-4" data-id="element-409">
          <Heart className="w-5 h-5 fill-current" data-id="element-410" />
          LO QUE DICEN LAS FAMILIAS QUE YA LO TIENEN
        </div>
      </div>

      <div className="columns-1 md:columns-2 gap-6 space-y-6 max-w-5xl mx-auto relative z-10" data-id="element-411">
        {testimonials.map((t, idx) => <div key={idx} className="break-inside-avoid" data-id="element-412">
            <Testimonial {...t} data-id="element-413" />
          </div>)}
      </div>
    </Section>;
}